<cipo-dialog-header [title]="title() | translate" closeTestId="note-dialog-close" />
<mat-dialog-content>
    <div class="p-t-md">
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            class="cipo--max-width--300 cipo--border--solid cipo--border-radius--sm p-a-sm">
            <div fxFlex="none" fxLayoutAlign="center center" class="file-chip__preview">
                @if (data.file.thumbnail200) {
                    <cipo-img-base64
                        [base64]="data.file.thumbnail200"
                        [mimetype]="data.file.mimeType"
                        [width]="64"
                        [height]="64"
                        radius="4px"
                        [alt]="data.file.name" />
                } @else {
                    <img
                        class="cipo--display--block"
                        [src]="fileTypeIcon()"
                        width="64"
                        height="64"
                        alt=""
                        aria-hidden="true" />
                }
            </div>
            <span class="cipo--min-width--0 cipo--text--ellipsed cipo-text--black-800" [title]="data.file.name">
                {{ data.file.name }}
            </span>
        </div>
    </div>
    @if (loading()) {
        <div
            class="p-t-md"
            data-testid="note-dialog-skeleton"
            role="status"
            [attr.aria-busy]="true"
            [attr.aria-label]="'a11y.fileExplorer.loadingNote' | translate">
            <ngx-skeleton-loader [theme]="{ width: '80px', height: '16px', margin: '0 0 8px' }" />
            <ngx-skeleton-loader
                class="cipo--display--block"
                [theme]="{ width: '100%', height: '112px', margin: '0px' }" />
        </div>
    } @else {
        <mat-form-field appearance="outline" class="cipo--width--full p-t-md">
            <mat-label>{{ "fileExplorer.note" | translate }}</mat-label>
            <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="10"
                [maxlength]="maxLength"
                [ngModel]="note()"
                (ngModelChange)="note.set($event)"
                [placeholder]="'fileExplorer.notePlaceholder' | translate"
                data-testid="note-dialog-input"></textarea>
            <mat-hint align="end">{{ note().length }} / {{ maxLength }}</mat-hint>
        </mat-form-field>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close data-testid="note-dialog-cancel">
        {{ "general.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" [disabled]="loading()" (click)="save()" data-testid="note-dialog-save">
        {{ "general.save" | translate }}
    </button>
</mat-dialog-actions>
